module.exports = __webpack_public_path__ + "static/img/wiok.9bda4e1e.webp";